export const focusPermissions = (actions: Set<string>) => {
  const VIEW_DASHBOARD = actions.has('view-dashboard')
  const UPDATE_RECOMMENDATIONS = actions.has('update-recommendations')

  return {
    UPDATE_RECOMMENDATIONS,
    VIEW_DASHBOARD,
  }
}
